export const environment = {
  production: false,
  apiUrl: '/api',
  baseUrl: ''  // Empty for relative URLs - works with any backend port
};
